var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import MaskedInputController from '../../../time-input/src/controllers/masked-input-controller';
var DateInputMaskController = /** @class */ (function (_super) {
    __extends(DateInputMaskController, _super);
    function DateInputMaskController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autocompleteNextChange = true;
        return _this;
    }
    DateInputMaskController.prototype.setNode = function (node) {
        this.node = node;
    };
    DateInputMaskController.prototype.sendChangeIfNeeded = function (value) {
        this.changeListener(value);
    };
    DateInputMaskController.prototype.changeListener = function (value) {
        if (value === void 0) { value = this.component.getValue(); }
        if (value !== this.confirmedValue) {
            // Do not autocomplete if input is empty
            value = value && this.autocompleteNextChange ? this.format.autoComplete(value) : value;
            this.confirmedValue = value;
            this.component.notifyChange(value);
        }
    };
    return DateInputMaskController;
}(MaskedInputController));
export default DateInputMaskController;
//# sourceMappingURL=date-input-mask-controller.js.map